exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".signature-pad {\n  position: relative;\n}\n.signature-pad:before {\n  content: \"\";\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  padding-top: 100%;\n  pointer-events: none;\n  display: block;\n}\n.signature-pad canvas {\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  background: #fff;\n  border: 1px #000 solid;\n}", ""]);

// exports
